import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function BreadcrumbSchema() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // If we are on the home page, no breadcrumb is strictly necessary
  // but we can return the Home alone, though usually omit is fine.
  if (pathnames.length === 0) return null;

  const breadcrumbList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://ionicerrrrscode.com',
      },
    ],
  };

  let currentPath = '';

  pathnames.forEach((name, index) => {
    currentPath += `/${name}`;
    // Format the name: capitalize and replace hyphens with spaces
    const formattedName = name
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    
    // For dynamic IDs like project references, we could map them, but 
    // replacing the hyphenated ID with Title Case is generally okay or we can just emit it.
    
    breadcrumbList.itemListElement.push({
      '@type': 'ListItem',
      position: index + 2,
      name: formattedName,
      item: `https://ionicerrrrscode.com${currentPath}`,
    });
  });

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbList)}
      </script>
    </Helmet>
  );
}
